import type { ConfigurableProductOptions } from '@pylot-data/pylotschema'
import type { SelectedOptions } from '../../../types/SelectedOptions'

/**
 * Converts received preselected options to the accepted type
 * @param configurableOptions configurable product options
 * @param preselectedOptionsRaw {[option id]: option value}.
 * Example: { 93: "Black White", 187: "S" }
 * @returns converted options of format { color: "Black White", size: "S" }
 */
export const convertPreselectedOptions = (
    configurableOptions: ConfigurableProductOptions[] | undefined,
    preselectedOptionsRaw?: Record<string, string>
): SelectedOptions => {
    if (!preselectedOptionsRaw || !configurableOptions) return {}

    return (configurableOptions as ConfigurableProductOptions[]).reduce(
        (acc, opt) => {
            const { attribute_code, uid } = opt
            const preselectedValue = preselectedOptionsRaw[uid!]
            if (!preselectedValue) return acc
            return {
                ...acc,
                [attribute_code as keyof SelectedOptions]: preselectedValue
            }
        },
        {}
    ) as SelectedOptions
}
